import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, TargetEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsDefined, IsEnum, IsISO8601, IsNotEmpty, IsOptional, IsString, MinLength, ValidateNested } from 'class-validator';
import { LevelTypeEnum, StoreItemTypeEnum, StoreItemsExposeGroup, TagEnum } from '../enum';
import { ReadAbstractItemMetadataDto } from './ReadAbstractItemMetadataDto';
export class ReadAbstractItemDto {
}
__decorate([
    ApiProperty({ enum: StoreItemTypeEnum, description: 'Item type', example: StoreItemTypeEnum.ITEM_BASE }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsEnum(StoreItemTypeEnum, { always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Item unique identifier', example: '8cfb627f-ea50-4508-a820-57b821e2e0f9' }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "uniqueName", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Store unique identifier', example: '8cfb627f-ea50-4508-a820-57b821e2e0f9' }),
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_PATCH, StoreItemsExposeGroup.BATCH_CREATE] }),
    IsOptional({ groups: [StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Merchant unique identifier', example: '8cfb627f-ea50-4508-a820-57b821e2e0f9' }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ enum: TargetEnum, example: TargetEnum.ONLINE }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.BATCH_CREATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
        ],
    }),
    IsOptional({
        groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH],
    }),
    IsEnum(TargetEnum, { always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "target", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadAbstractItemDto.prototype, "isArchived", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadAbstractItemDto.prototype, "isAvailable", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsISO8601({}, { always: true }),
    __metadata("design:type", Object)
], ReadAbstractItemDto.prototype, "isAvailableAt", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadAbstractItemDto.prototype, "isOrderable", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadAbstractItemDto.prototype, "isVisible", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    MinLength(1, { always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "title", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "globalIdentifier", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsDefined({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    __metadata("design:type", ReadAbstractItemMetadataDto)
], ReadAbstractItemDto.prototype, "metadata", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "internalName", void 0);
__decorate([
    Expose({ groups: [StoreItemsExposeGroup.READ, StoreItemsExposeGroup.BATCH_CREATE, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsOptional({ groups: [StoreItemsExposeGroup.BATCH_PATCH] }),
    IsEnum(LevelTypeEnum, { always: true }),
    __metadata("design:type", String)
], ReadAbstractItemDto.prototype, "levelType", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsEnum(TagEnum, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadAbstractItemDto.prototype, "tags", void 0);
//# sourceMappingURL=ReadAbstractItemDto.js.map